"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cllk = void 0;
exports.cllk = {
    A: "http://lojban.github.io/cll/14/6/",
    BAI: "http://lojban.github.io/cll/9/6/",
    BAhE: "http://lojban.github.io/cll/19/11/",
    BE: "http://lojban.github.io/cll/5/7/",
    BEI: "http://lojban.github.io/cll/5/7/",
    BEhO: "http://lojban.github.io/cll/5/7/",
    BIhE: "http://lojban.github.io/cll/18/5/",
    BIhI: "http://lojban.github.io/cll/14/16/",
    BO: "http://lojban.github.io/cll/5/3/ http://lojban.github.io/cll/15/6/ http://lojban.github.io/cll/18/17/",
    BOI: "http://lojban.github.io/cll/18/6/",
    BU: "http://lojban.github.io/cll/17/4/",
    BY: "http://lojban.github.io/cll/17/2/",
    CAI: "http://lojban.github.io/cll/13/4/",
    CAhA: "http://lojban.github.io/cll/10/19/",
    CEI: "http://lojban.github.io/cll/7/5/",
    CEhE: "http://lojban.github.io/cll/14/11/ http://lojban.github.io/cll/16/7/",
    CO: "http://lojban.github.io/cll/5/8/",
    COI: "http://lojban.github.io/cll/6/11/ http://lojban.github.io/cll/13/14/",
    CU: "http://lojban.github.io/cll/9/2/",
    CUhE: "http://lojban.github.io/cll/10/24/",
    DAhO: "http://lojban.github.io/cll/7/13/",
    DOI: "http://lojban.github.io/cll/13/14/",
    DOhU: "http://lojban.github.io/cll/13/14/",
    FA: "http://lojban.github.io/cll/9/3/",
    FAhA: "http://lojban.github.io/cll/10/2/",
    FAhO: "http://lojban.github.io/cll/19/15/",
    FEhE: "http://lojban.github.io/cll/10/11/",
    FEhU: "http://lojban.github.io/cll/9/5/",
    FIhO: "http://lojban.github.io/cll/9/5/",
    FOI: "http://lojban.github.io/cll/17/6/",
    FUhA: "http://lojban.github.io/cll/18/16/",
    FUhE: "http://lojban.github.io/cll/19/8/",
    FUhO: "http://lojban.github.io/cll/19/8/",
    GA: "http://lojban.github.io/cll/14/5/",
    GAhO: "http://lojban.github.io/cll/14/16/",
    GEhU: "http://lojban.github.io/cll/8/3/",
    GI: "http://lojban.github.io/cll/14/5/",
    GIhA: "http://lojban.github.io/cll/14/3/",
    GOI: "http://lojban.github.io/cll/8/3/",
    GOhA: "http://lojban.github.io/cll/7/6/",
    GUhA: "http://lojban.github.io/cll/14/3/",
    I: "http://lojban.github.io/cll/19/2/",
    JA: "http://lojban.github.io/cll/14/3/",
    JAI: "http://lojban.github.io/cll/9/12/",
    JOI: "http://lojban.github.io/cll/14/14/",
    JOhI: "http://lojban.github.io/cll/18/15/",
    KE: "http://lojban.github.io/cll/5/5/",
    KEI: "http://lojban.github.io/cll/11/1/",
    KEhE: "http://lojban.github.io/cll/5/5/",
    KI: "http://lojban.github.io/cll/10/13/",
    KOhA: "http://lojban.github.io/cll/7/1/",
    KOhA2: "http://lojban.github.io/cll/7/4/",
    KOhA3: "http://lojban.github.io/cll/7/2/",
    KOhA4: "http://lojban.github.io/cll/7/5/",
    KOhA5: "http://lojban.github.io/cll/7/6/",
    KOhA6: "http://lojban.github.io/cll/7/3/",
    KOhA7: "http://lojban.github.io/cll/7/7/",
    KU: "http://lojban.github.io/cll/6/2/ http://lojban.github.io/cll/10/1/",
    KUhE: "http://lojban.github.io/cll/18/6/",
    KUhO: "http://lojban.github.io/cll/8/1/",
    LA: "http://lojban.github.io/cll/6/2/",
    LAU: "http://lojban.github.io/cll/17/14/",
    LAhE: "http://lojban.github.io/cll/6/10/",
    LE: "http://lojban.github.io/cll/6/2/",
    LEhU: "http://lojban.github.io/cll/19/9/",
    LI: "http://lojban.github.io/cll/18/5/",
    LIhU: "http://lojban.github.io/cll/19/9/",
    LOhO: "http://lojban.github.io/cll/18/17/",
    LOhU: "http://lojban.github.io/cll/19/9/",
    LU: "http://lojban.github.io/cll/19/9/",
    LUhU: "http://lojban.github.io/cll/6/10/",
    MAI: "http://lojban.github.io/cll/18/19/ http://lojban.github.io/cll/19/1/",
    MAhO: "http://lojban.github.io/cll/18/6/",
    ME: "http://lojban.github.io/cll/5/10/ http://lojban.github.io/cll/18/1/",
    MEhU: "http://lojban.github.io/cll/5/11/",
    MOI: "http://lojban.github.io/cll/5/11/",
    MOhE: "http://lojban.github.io/cll/18/18/",
    MOhI: "http://lojban.github.io/cll/10/8/",
    NA: "http://lojban.github.io/cll/14/3/ http://lojban.github.io/cll/15/7/",
    NAI: "http://lojban.github.io/cll/14/3/ http://lojban.github.io/cll/15/7/",
    NAhE: "http://lojban.github.io/cll/15/4/",
    NAhU: "http://lojban.github.io/cll/18/18/",
    NIhE: "http://lojban.github.io/cll/18/18/",
    NIhO: "http://lojban.github.io/cll/19/3/",
    NOI: "http://lojban.github.io/cll/8/1/",
    NU: "http://lojban.github.io/cll/11/1/",
    NUhA: "http://lojban.github.io/cll/18/19/",
    NUhI: "http://lojban.github.io/cll/14/11/ http://lojban.github.io/cll/16/7/",
    NUhU: "http://lojban.github.io/cll/14/11/",
    PA: "http://lojban.github.io/cll/18/2/",
    PEhE: "http://lojban.github.io/cll/14/11/",
    PEhO: "http://lojban.github.io/cll/18/6/",
    PU: "http://lojban.github.io/cll/10/4/",
    RAhO: "http://lojban.github.io/cll/7/6/",
    ROI: "http://lojban.github.io/cll/10/9/",
    SA: "http://lojban.github.io/cll/19/13/",
    SE: "http://lojban.github.io/cll/5/1/ http://lojban.github.io/cll/9/4/",
    SEI: "http://lojban.github.io/cll/19/12/",
    SEhU: "http://lojban.github.io/cll/19/12/",
    SI: "http://lojban.github.io/cll/19/13/",
    SOI: "http://lojban.github.io/cll/7/8/",
    SU: "http://lojban.github.io/cll/19/13/",
    TAhE: "http://lojban.github.io/cll/10/9/",
    TEI: "http://lojban.github.io/cll/17/6/",
    TEhU: "http://lojban.github.io/cll/18/15/",
    TO: "http://lojban.github.io/cll/19/12/",
    TOI: "http://lojban.github.io/cll/19/12/",
    TUhE: "http://lojban.github.io/cll/19/2/",
    TUhU: "http://lojban.github.io/cll/19/2/",
    UI: "http://lojban.github.io/cll/13/1/",
    UI1: "http://lojban.github.io/cll/13/2/ http://lojban.github.io/cll/13/3/",
    UI2: "http://lojban.github.io/cll/13/11/",
    UI3a: "http://lojban.github.io/cll/13/13/",
    UI3b: "http://lojban.github.io/cll/13/12/",
    UI4: "http://lojban.github.io/cll/13/6/",
    UI5: "http://lojban.github.io/cll/13/7/",
    UI6: "http://lojban.github.io/cll/13/13/",
    VA: "http://lojban.github.io/cll/10/2/",
    VAU: "http://lojban.github.io/cll/14/9/",
    VEI: "http://lojban.github.io/cll/18/5/",
    VEhA: "http://lojban.github.io/cll/10/5/",
    VEhO: "http://lojban.github.io/cll/19/5/",
    VIhA: "http://lojban.github.io/cll/10/7/",
    VUhO: "http://lojban.github.io/cll/8/8/",
    VUhU: "http://lojban.github.io/cll/18/5/",
    XI: "http://lojban.github.io/cll/18/13/",
    Y: "http://lojban.github.io/cll/19/14/",
    ZAhO: "http://lojban.github.io/cll/10/10/",
    ZEI: "http://lojban.github.io/cll/4/6/",
    ZEhA: "http://lojban.github.io/cll/10/5/ https://lojban.github.io/cll/10/9/",
    ZI: "http://lojban.github.io/cll/10/4/",
    ZIhE: "http://lojban.github.io/cll/8/4/",
    ZO: "http://lojban.github.io/cll/19/10/",
    ZOI: "http://lojban.github.io/cll/19/10/",
    ZOhU: "http://lojban.github.io/cll/16/2/ http://lojban.github.io/cll/19/4/",
};
